/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function CreateAction({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/CreateAction",
  isDisabled,
  onSubmit
  
}) {
let newProfessionalSubmitData = fromData.useDataSubmit({ viewPath,
context: 'new_professional',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 block={true}
 disabled={isDisabled}
 data="new_professional"
 onClick={newProfessionalSubmitData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Add Profesional"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}